import api from '../../../api/axios';

export const bannerService = {
  saveBanner: async (slug, data) => {
    const formData = new FormData();
    formData.append('text', data.text);
    formData.append('buttonText', data.buttonText); // Ahora el backend lo leerá
    
    // Solo adjuntamos si SON archivos nuevos. Si son null, el backend mantiene los anteriores.
    if (data.logo instanceof File) formData.append('logo', data.logo);
    if (data.background instanceof File) formData.append('background', data.background);

    const token = localStorage.getItem('token');
    const response = await api.put(`/admin/template/${slug}/banner`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  validateImage: (file, maxSizeMB = 5) => {
    if (!file) return { valid: false, error: 'No se seleccionó ningún archivo' };
    const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'];
    if (!validTypes.includes(file.type)) {
      return { valid: false, error: 'Formato no permitido. Usa PNG, JPG, JPEG o WEBP.' };
    }
    const maxSizeBytes = maxSizeMB * 1024 * 1024;
    if (file.size > maxSizeBytes) {
      return { valid: false, error: `La imagen no debe superar los ${maxSizeMB}MB.` };
    }
    return { valid: true };
  },

  readFileAsURL: (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => resolve(e.target.result);
      reader.onerror = (e) => reject(e);
      reader.readAsDataURL(file);
    });
  }
};